module.exports = __webpack_public_path__ + "static/media/tm7.7ac0130c.jpg";